/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOvalVertical = createReactComponent("oval-vertical", "IconOvalVertical", [
  [
    "path",
    {
      d: "M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6z",
      key: "svg-0"
    }
  ]
]);

export { IconOvalVertical as default };
//# sourceMappingURL=IconOvalVertical.js.map
